(ns ui.editor2.sidebar-text-presets
  (:require [ui.editor2.text :as text]))

(defn entry
  [selected]
  [:div
   {:class ["flex" "pt-3" "pb-3" "pl-2" "pr-2" "flex-col" "justify-center" "items-center" "gap-1" "rounded-lg" "cursor-pointer" "hover:bg-gray-600"
            (when selected
              "bg-gray-800")]
    :on {:click [[:store/assoc-in
                  [:editor2 :sidebar-panel]
                  :text-presets]]}}
   [:i.fas.fa-font {:class (if selected
                             "text-slate-200"
                             "text-slate-400")}]
   [:span
    {:class ["text-center" "text-xs" "font-medium" "font-medium"
             (when-not selected
               "text-slate-400") ]}
    "Text"]])

(defn to-json-string
  "Unfortunately, we need to use json strings since the json data of a
   Prosemirror document still contains not serialized objects. This
   is a problem for saving and loading text elements of a design blob."
  [preset]
  (js/JSON.stringify (clj->js preset)))

(def text-presets
  [{:name "Classic"
    :doc {:type "doc",
          :content [{:type "paragraph",
                     :attrs {:align "left"},
                     :content [{:type "text",
                                :marks [{:type "fontFamily",
                                         :attrs {:fontFamily "Classic"}}
                                        {:type "fontSize",
                                         :attrs {:fontSize "30"}}
                                        {:type "color"
                                         :attrs {:color "#ffffff"}}
                                        {:type "bold"}],
                                :text "Classic"}]}]}}
   {:name "Modern"
    :doc {:type "doc",
          :content [{:type "paragraph",
                     :attrs {:align "left"},
                     :content [{:type "text",
                                :marks [{:type "fontFamily",
                                         :attrs {:fontFamily "Modern"}}
                                        {:type "fontSize",
                                         :attrs {:fontSize "30"}}
                                        {:type "color"
                                         :attrs {:color "#ffffff"}}],
                                :text "Modern"}]}]}}
   {:name "Bubble"
    :doc {:type "doc",
                :content [{:type "paragraph",
                           :attrs {:align "left"},
                           :content [{:type "text",
                                      :marks [{:type "fontFamily",
                                               :attrs {:fontFamily "Bubble"}}
                                              {:type "fontSize",
                                               :attrs {:fontSize "30"}}
                                              {:type "color"
                                               :attrs {:color "#ffffff"}}],
                                      :text "Bubble"}]}]}}
   {:name "Neon"
    :doc {:type "doc",
          :content [{:type "paragraph",
                     :attrs {:align "left"},
                     :content [{:type "text",
                                :marks [{:type "fontFamily",
                                         :attrs {:fontFamily "Neon"}}
                                        {:type "fontSize",
                                         :attrs {:fontSize "40"}}
                                        {:type "color"
                                         :attrs {:color "#ffffff"}}],
                                :text "Neon"}]}]}}
   {:name "Typewriter"
    :doc {:type "doc",
          :content [{:type "paragraph",
                     :attrs {:align "left"},
                     :content [{:type "text",
                                :marks [{:type "fontFamily",
                                         :attrs {:fontFamily "Typewriter"}}
                                        {:type "fontSize",
                                         :attrs {:fontSize "30"}}
                                        {:type "color"
                                         :attrs {:color "#ffffff"}}],
                                :text "Typewriter"}]}]}}

   {:name "Strong"
    :doc {:type "doc",
          :content [{:type "paragraph",
                     :attrs {:align "left"},
                     :content [{:type "text",
                                :marks [{:type "fontFamily",
                                         :attrs {:fontFamily "Strong"}}
                                        {:type "fontSize",
                                         :attrs {:fontSize "30"}}
                                        {:type "color"
                                         :attrs {:color "#ffffff"}}],
                                :text "Strong"}]}]}}])

(defn presets-panel
  [_state]
  ;; panel-grid-list
  [:div
   {:replicant/key "text-preset-panel"
    :class ["flex" "flex-col" "gap-2" "w-full"]}
   ;; panel-grid-list__content
   [:div
    {:class ["grid" "gap-2"]
     :style {:grid-template-columns "repeat(1, 1fr)"}}
    (for [text-preset text-presets]
      ;; media-card
      (let [edn-doc (:doc text-preset)
            doc (.nodeFromJSON text/custom-schema
                               (clj->js edn-doc))
            hiccup (text/get-doc-hiccup doc)]
        [:div
         {:class ["flex" "flex-col" "gap-1.5" "w-full" "relative" "cursor-pointer"]
          :on {:click [[:editor2/add-text-preset-as-clip! {:name (:name text-preset)
                                                           :text (.-textContent doc)
                                                           :hiccup (text/add-font-padding hiccup)
                                                           :saved-doc (to-json-string edn-doc)}]]}}
         ;; thumbnail
         [:div
          {:class ["rounded-lg" "overflow-hidden" "relative" "w-full" "flex" "justify-center" "bg-gray-900"]
           :style {:filter "blur(0)"
                   :height "3.375rem"}}
          [:div
           {:class ["flex" "items-center" "justify-center" "h-full" "object-contain" "max-w-full" "w-full" "pointer-events-none"]}
           hiccup
           ]]
         ]))]])